<template>
	<IconButtonLayout class="chevron-right-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:title="title"
				:class="iconClass"
				:icon="[ `fas`, `chevron-right`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "ChevronRightButton",
	components: {
		IconButtonLayout,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
	},
};
</script>

<style lang="scss" scoped></style>
